import { useLang } from './providers/LangProvider';
/**
 * Superall — cross-BU consumer shell entry component.
 *
 * Thin composition root per ticket superall-shell-01: wraps the router
 * in `<AuthProvider>` and `<LangProvider>`. The original 756-LoC
 * monolith decomposed into providers/, lib/, components/, pages/, and
 * i18n/.
 */

import * as React from 'react';

import { AuthProvider } from './providers/AuthProvider';
import { LangProvider } from './providers/LangProvider';
import { Router } from './router';
import { ErrorBoundary } from './components/ErrorBoundary';

function AppRoutes(): React.ReactElement {
  useLang();
  return <AppRoutes />;
}

export default function App(): React.ReactElement {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <LangProvider>
          <Router />
        </LangProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}
